import Wren from '../assets/img/clients/wren.png';
import LHP from '../assets/img/clients/lhp-logo-v2 copy.png';
import Rotate from '../assets/img/clients/Rotate Logo.png';
import SocialSociety from '../assets/img/clients/SSOC_LOGO_circle_white_transparent.png';
import ArtWalk from '../assets/img/clients/ArtWalk.png';
import Loanzify from '../assets/img/clients/loanzify.png';

export const clientsAndFriends = [
  {
    src: Wren,
    alt: 'Wren Natural',
  },
  {
    src: Rotate,
    alt: 'Rotate',
  },
  {
    src: ArtWalk,
    alt: 'Downtown Redlands Art Walk',
  },
  {
    src: SocialSociety,
    alt: 'Social Society OC',
  },
  {
    src: LHP,
    alt: 'LenderHomePage.com',
  },
  {
    src: Loanzify,
    alt: 'Loanzify',
  },
];



// WEBPACK FOOTER //
// ./src/data/clients-and-friends.js